<template>
  <v-dialog v-model="show" max-width="512" persistent>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-text-container">
          <h1 class="modal-text-title">{{ adminText('organizationAll.add_promo_code_ae7b6a21', 'Add promo code') }}</h1>
          <div class="modal-text-info">
            <p class="modal-text-info-step">{{ adminText('organizationAll.step_dc416e10', 'Step') }} {{ step }}</p>
            <p class="modal-text-info-step">{{ organizationText(stepper.find(s => s.id === step).text) }}</p>
          </div>
        </div>
        <v-icon color="#979797" class="close-icon" @click="cancel">close</v-icon>
      </div>
      <div v-if="step === 1" class="discount-options-container">
        <div class="discount-option" @click="handleDiscountOptionSelect('PERCENTAGE')">
          <img
            class="discount-option-icon"
            src="/assets/discount-percentage-icon.svg"
            :alt="adminText('organizationAll.discount_percentage_a0ebde53', 'Discount percentage')"
          >
          <div class="discount-option-title">{{ adminText('organizationAll.discount_percentage_a0ebde53', 'Discount percentage') }}</div>
        </div>
        <div class="discount-option" @click="handleDiscountOptionSelect('AMOUNT')">
          <img
            class="discount-option-icon"
            src="/assets/discount-amount-icon.svg"
            :alt="adminText('organizationAll.discount_amount_cba15337', 'Discount amount')"
          >
          <h4 class="discount-option-title">{{ adminText('organizationAll.discount_amount_cba15337', 'Discount amount') }}</h4>
        </div>
      </div>
      <div v-else class="main-container">
        <div v-if="step === 2" class="form-container">
          <select-field-multiple
            v-model="form.eventIds"
            :validator="vs.form.eventIds"
            :label="adminText('organizationAll.event_baf6e358', 'Event*')"
            :items="allEvents"
            item-render="title"
            item-select="id"
          />
          <select-field-multiple
            v-if="performances.length"
            v-model="form.performanceIds"
            :validator="vs.form.performanceIds"
            :error-messages="{
              selectedPerformances: adminText('organizationAll.please_select_performances_for_all_selected_e_c17478a9', 'Please select performances for all selected events'),
            }"
            :label="adminText('organizationAll.performance_e4aee885', 'Performance*')"
            :items="performances"
            item-render="title"
            item-select="id"
          />
          <select-field-multiple
            v-model="form.orderItemIds"
            :disabled="!form.eventIds.length"
            :validator="vs.form.orderItemIds"
            :error-messages="{
              selectedOrderItems: adminText('organizationAll.please_select_tickets_for_all_selected_events_7c58b70d', 'Please select tickets for all selected events'),
            }"
            :label="adminText('organizationAll.ticket_5be34f36', 'Ticket*')"
            :items="orderItems"
            item-render="name"
            item-select="id"
          />
        </div>
        <div v-if="step === 3" class="form-container">
          <text-field
            id="name"
            v-model.trim="form.name"
            :label="adminText('organizationAll.name_57162c35', 'Name*')"
            type="text"
            :validator="vs.form.name"
          />
          <text-field
            id="code"
            v-model.trim="form.code"
            :label="adminText('organizationAll.unique_promo_code_bceba6f4', 'Unique Promo code*')"
            type="text"
            :validator="vs.form.code"
          />
          <text-field
            v-if="form.discountType === 'PERCENTAGE'"
            id="discountPercentage"
            v-model.number="form.discountPercentage"
            :label="adminText('organizationAll.discount_percentage_89e75436', 'Discount percentage*')"
            type="number"
            :validator="vs.form.discountPercentage"
            append-icon="percent"
            prepend-icon="remove"
          />
          <text-field
            v-else
            id="discountAmount"
            v-model.number="form.discountAmount"
            :label="adminText('organizationAll.discount_amount_05ae2995', 'Discount amount*')"
            type="number"
            :validator="vs.form.discountAmount"
            append-icon="euro"
            prepend-icon="remove"
          />
          <text-field
            id="quantityPerTicket"
            v-model.number="form.quantityPerTicket"
            :label="adminText('organizationAll.orders_quantity_c8ce5608', 'Orders quantity*')"
            type="number"
            :disabled="form.unlimited"
            :validator="vs.form.quantityPerTicket"
          />
          <checkbox v-model="form.unlimited" :validator="vs.form.unlimited" color="#0277bd">
            <p class="unlimited-checkbox">{{ adminText('organizationAll.unlimited_quantity_d261fab6', 'Unlimited quantity') }}</p>
          </checkbox>
          <text-field
            id="ticketsPerOrder"
            v-model.number="form.ticketsPerOrder"
            :label="adminText('organizationAll.max_tickets_per_order_17b8e39e', 'Max tickets per order*')"
            type="number"
            :validator="vs.form.ticketsPerOrder"
          />
          <div class="dates-container">
            <datetime-field
              v-model="form.from"
              :validator="vs.form.from"
              :label="adminText('organizationAll.start_date_2fde03a5', 'Start date*')"
              :min="new Date().toISOString()"
              :error-messages="{
                minDate: adminText('organizationAll.start_date_must_be_a_future_date_49b63d67', 'Start date must be a future date'),
                maxDate: adminText('organizationAll.start_date_should_be_before_the_end_of_the_ev_d4de23c0', 'Start date should be before the end of the event'),
              }"
            />
            <datetime-field
              v-model="form.to"
              :validator="vs.form.to"
              :label="adminText('organizationAll.end_date_dc7fcbdc', 'End date*')"
              :min="form.from ? new Date(form.from).toISOString() : new Date().toISOString()"
              :error-messages="{
                minDate: adminText('organizationAll.start_date_must_be_a_future_date_49b63d67', 'Start date must be a future date'),
                maxDate: adminText('organizationAll.start_date_should_be_before_the_end_of_the_ev_d4de23c0', 'Start date should be before the end of the event'),
              }"
            />
          </div>
          <div v-if="isPauseVisible" class="pause-container">
            <h1 class="modal-text-title">{{ adminText('organizationAll.pause_781961bc', 'Pause') }}</h1>
            <div class="dates-container">
              <datetime-field
                v-model="form.pauseFrom"
                :validator="vs.form.pauseFrom"
                :label="adminText('organizationAll.pause_start_date_c6c3497d', 'Pause start date*')"
                :min="form.from ? new Date(form.from).toISOString() : new Date().toISOString()"
                :max="form.to ? new Date(form.to).toISOString() : null"
                :error-messages="{
                  minDate: adminText('organizationAll.pause_start_should_be_during_the_promo_code_a_78958e87', 'Pause start should be during the promo code active period'),
                  maxDate: adminText('organizationAll.pause_start_should_be_before_the_pause_end_da_4d119662', 'Pause start should be before the pause end date'),
                }"
              />
              <datetime-field
                v-model="form.pauseTo"
                :validator="vs.form.pauseTo"
                :label="adminText('organizationAll.pause_end_date_b044a084', 'Pause end date*')"
                :min="
                  form.pauseFrom ? new Date(form.pauseFrom).toISOString() : new Date().toISOString()
                "
                :max="form.to ? new Date(form.to).toISOString() : null"
                :error-messages="{
                  minDate: adminText('organizationAll.pause_end_should_be_after_the_pause_start_dat_c20d9b26', 'Pause end should be after the pause start date'),
                  maxDate: adminText('organizationAll.pause_end_should_be_during_the_promo_code_act_edd4f9e5', 'Pause end should be during the promo code active period'),
                }"
              />
            </div>
            <main-button
              flat
              color="error"
              @click="handleRemovePause"
            >
              <v-icon size="24" color="error" class="add-pause-icon">delete</v-icon>{{ adminText('organizationAll.remove_pause_904aaa1c', 'Remove pause') }}
            </main-button>
          </div>
          <main-button
            v-else
            flat
            @click="showPauseFields = true"
          >
            <v-icon size="24" color="#0277BD" class="add-pause-icon">add</v-icon>{{ adminText('organizationAll.add_pause_159e078a', 'Add pause') }}
          </main-button>
        </div>
        <div class="buttons-container">
          <main-button outline @click="handleBack">{{ adminText('organizationAll.back_61bb8d29', 'back') }}</main-button>
          <main-button :disabled="!canGoNext" @click="handleNext">
            {{ step === 2 ? adminText('organizationAll.next_edee9402', 'next') : adminText('organizationAll.finish_2cce4a92', 'finish') }}
          </main-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { intersection, isEqual, pick } from 'lodash'

const stepper = [
  {
    id: 1,
    text: 'Choose Promo code type',
  },
  {
    id: 2,
    text: 'Choose Event and Ticket',
  },
  {
    id: 3,
    text: 'Add Promo code details',
  },
]
export default {
  mixins: [OrganizationLocalization],
  name: 'create-promo-code-modal',
  props: {
    show: Boolean,
    initialValues: Object,
    vs: Object,
    allEvents: Array,
    performances: Array,
    orderItems: Array,
  },
  data() {
    return { form: { ...this.initialValues }, stepper, step: 1, showPauseFields: false }
  },
  computed: {
    isPauseVisible() {
      return this.showPauseFields || Boolean(this.form.pauseFrom || this.form.pauseTo)
    },
    canGoNext() {
      return this.step === 2
        ? !this.vs.form.eventIds.$invalid &&
            !this.vs.form.performanceIds.$invalid &&
            !this.vs.form.orderItemIds.$invalid
        : !this.vs.form.name.$invalid &&
            !this.vs.form.code.$invalid &&
            !this.vs.form.quantityPerTicket.$invalid &&
            !this.vs.form.unlimited.$invalid &&
            !this.vs.form.ticketsPerOrder.$invalid &&
            !this.vs.form.discountPercentage.$invalid &&
            !this.vs.form.discountAmount.$invalid &&
            !this.vs.form.from.$invalid &&
            !this.vs.form.to.$invalid &&
            !this.vs.form.pauseFrom.$invalid &&
            !this.vs.form.pauseTo.$invalid
    },
  },
  watch: {
    form: {
      handler(val) {
        const newForm = { ...val }

        newForm.performanceIds = intersection(
          newForm.performanceIds,
          this.performances
            .filter(p => newForm.eventIds.includes(p.eventTemplate.id))
            .map(p => p.id),
        )
        newForm.orderItemIds = intersection(
          newForm.orderItemIds,
          this.orderItems
            .filter(oi =>
              [
                ...newForm.eventIds,
                ...(newForm.performanceIds ? newForm.performanceIds : []),
              ].includes(oi.eventId),
            )
            .map(p => p.id),
        )

        newForm.quantityPerTicket = newForm.unlimited ? null : newForm.quantityPerTicket

        if (!isEqual(this.form, newForm)) {
          this.form = newForm
        } else {
          this.$emit('update-form', newForm)
        }
      },
      deep: true,
    },
  },
  methods: {
    resetFormState() {
      this.vs.form.$reset()
      this.form = { eventIds: [], performanceIds: [], orderItemIds: [] }
      this.step = 1
      this.$emit('update-form', this.form)
    },
    closeDialog() {
      this.$emit('update:show', false)
    },
    cancel() {
      this.resetFormState()
      this.closeDialog()
    },
    handleDiscountOptionSelect(type) {
      this.form = { ...this.form, discountType: type }
      this.step = 2
    },
    handleRemovePause() {
      this.showPauseFields = false
      this.form = {
        ...this.form,
        pauseFrom: null,
        pauseTo: null,
      }
      this.vs.form.pauseFrom.$reset()
      this.vs.form.pauseTo.$reset()
    },
    handleBack() {
      if (this.step === 2) {
        this.form = { eventIds: [], performanceIds: [], orderItemIds: [] }
      } else {
        this.form = pick(this.form, [
          'discountType',
          'eventIds',
          'performanceIds',
          'orderItemIds',
          'pauseFrom',
          'pauseTo',
        ])
      }
      this.step -= 1
      this.vs.form.$reset()
    },
    handleNext() {
      if (this.step === 3) {
        this.$emit('create-promo-code')
      } else {
        this.step += 1
      }
    },
  },
}
</script>

<style scoped>
.modal-container {
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(51, 51, 51, 0.2);
  border-radius: 12px;
  padding: 24px 24px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.modal-header {
  display: flex;
  align-items: baseline;
}
.modal-text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.modal-text-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.modal-text-info {
  display: flex;
  flex-direction: column;
}
.modal-text-info-step {
  margin: 0%;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #979797;
}
.close-icon {
  cursor: pointer;
  user-select: none;
}
.discount-options-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.discount-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  gap: 12px;
  background: #f5f5f5;
  border: 2px solid #d9d9d9;
  border-radius: 12px;
}
.discount-option:hover {
  cursor: pointer;
  background: #e6f1f8;
  border: 2px solid #cee4f2;
  border-radius: 12px;
}
.discount-option:active {
  cursor: pointer;
  background: #cee4f2;
  border: 2px solid #0277bd;
  border-radius: 12px;
}
.discount-option-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.discount-option-icon {
  user-select: none;
}
.main-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0%;
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dates-container {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
}
.unlimited-checkbox {
  margin-bottom: 0;
}
.add-pause-button {
  align-items: center;
  align-self: center;
  background: transparent;
  border: 0;
  border-radius: 24px;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  justify-content: center;
  padding: 12px 24px;
}
.pause-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.add-pause-icon {
  flex-shrink: 0;
}
.add-pause-text {
  color: #0277bd;
  font-family: 'Raleway', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.27px;
  line-height: 120%;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
}
.remove-pause-button {
  align-self: flex-start;
  background: transparent;
  border: 0;
  color: #0277bd;
  cursor: pointer;
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 700;
  padding: 0;
  text-transform: uppercase;
}
@media screen and (max-width: 600px) {
  .dates-container {
    flex-direction: column;
  }
}
</style>
